<template>
  <font-awesome-icon
    icon="reply-all"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faReplyAll } from '@fortawesome/free-solid-svg-icons'

library.add(faReplyAll)

export default {
  name: 'CoozzyReplyAllIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
